

function BoxDescription({ item, display, setDisplay }) {

    return (
        <div className="w-full">
            <p className="text-xs text-slate-500 mb-2 drtl">
                {((item.description.length > 140) && (!display)) ?
                    item.description.substring(0, 140).concat(" ... ")
                    :
                    item.description
                }
            </p>
            <div className={`${item.description.length > 140 ? "flex-row-reverse w-full" : "flex-row w-full"}
                            flex justify-between`
            }>
                {item.description.length > 140 ?
                    <p className="text-blue-400 text-xs underline"
                        onClick={() => setDisplay(!display)}>
                        {display ? "پنهان" : "بیشتر"}
                    </p>
                    :
                    null
                }
                <div className="">
                    <span className="text-slate-400 text-xs"> {item.date}    </span>
                    <span className="text-slate-400 text-xs"> {item.time}</span>
                </div>
            </div>
        </div>
    )
}
export default BoxDescription;